import { useParams } from "react-router-dom";
import TeamPerformanceDetail from "./performance-detail";
import { useStateValue } from "../../context/StateProvider";
import BreadCrumbs from "../reuseable/breadcrumbs";
import PageHeader from "../PageHeader";

function MainTeamDetail() {
  const { id } = useParams();
  const [{ users }] = useStateValue();
  const selectedUser = users.find((u) => String(u.id) === String(id));
  if (!selectedUser) return <div>User not found</div>;

  const { firstname, lastname, role } = selectedUser;

  const getDataFromChild = (data) => {
    console.log("Data from child:", data);
  };

  return (
    <div>
      <PageHeader
        title={`${firstname} ${lastname}`}
        subtitle={`${role === "Admin" ? "Team Lead" : role === "Employee" ? "Real Estate Agent" : "Client Care"} · Performance Overview`}
      />
      <div className="px-10 mt-3">
        <BreadCrumbs
          crumb1="Team Performance"
          crumb2="Team Performance Detail"
          crumbLink1="/dashboard/team-management"
        />
      </div>
      <TeamPerformanceDetail id={id} childSelectedYear={getDataFromChild} />
    </div>
  );
}

export default MainTeamDetail;
